"use client";

import React, { useEffect } from "react";

import { Order } from "custom-types/Order";

import { getOrders } from "./getOrders";

const ChatInit = () => {
  const [orders, setOrders] = React.useState<Order[]>([]);

  useEffect(() => {
    getOrders().then((orders) => {
      setOrders(orders);
    });
  }, []);

  useEffect(() => {
    // conditionally import chat javascript, to avoid bloating bundle when there are no orders
    if (orders.length > 0) {
      const startChat = async () => {
        const ChatList = await import("./ChatList");
        // this avoids a race condition with elements being rendered on the dom
        setTimeout(() => new ChatList.default(orders), 0);
      };
      startChat();
    }
  }, [JSON.stringify(orders)]);

  return null;
};

export default ChatInit;
